import { APP_CONFIG } from '../../config';
import { get } from '../request';
import { ApiEndpoints } from '../apiEndpoints.constant';
import { KaeuferPlusLegalInsurance, KaeuferPlusLegalInsuranceApiResponse } from '@/@types/kaeuferPlusLegalInsurance';

export const getKaeuferPlusLegalInsurance = async (): Promise<KaeuferPlusLegalInsurance> => {
  const response: KaeuferPlusLegalInsuranceApiResponse = await get(
    `${APP_CONFIG.apiEndpoint}${ApiEndpoints.kauferPlusLegalInsurance}`,
  );
  return {
    active: response?.active || false,
    activationDate: response?.activationDate,
    expirationDate: response?.expirationDate,
  };
};
